/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	
	const createSlider = () => {
		if (document.querySelectorAll('.js-mod-slider01')) {
			document.querySelectorAll('.js-mod-slider01').forEach(ele => {
				const splide = new Splide(ele, {
					type: 'loop',
					perPage: 3,
					autoplay: true,
					autoWidth: true,
					focus: 0,
					gap: 40,
					updateOnMove: true,
					paginationKeyboard: true,
					perMove: 1,
					breakpoints: {
						1024: {
							perPage: 1,
							gap: 24,
						},
						768: {
						}
					}
				});
				splide.on('overflow', function (isOverflow) {
					splide.go(0);

					splide.options = {
						arrows: isOverflow,
						pagination: isOverflow,
						drag: isOverflow,
						clones: isOverflow ? undefined : 0
					};

					if (isOverflow) {
						ele.querySelector(".splide__pagination__wrap").classList.remove("di_none");
					} else {
						ele.querySelector(".splide__pagination__wrap").classList.add("di_none");
					}
				});
				splide.mount();
			});
		}
	};

	const initTopics = () => {
		const content = document.querySelector(".sustainability-top-content01");
		if(content) {
			let slideCount = content.querySelectorAll('.splide__slide').length;
			if(slideCount === 0) {
				content.classList.add("di_none")
			}
		}
	}
	
	createSlider();
	initTopics();

})(window.FUNCTIONS);
